// import React from 'react';

// const FeatureCard = ({ image, title, description }) => {
//   return (
//     <div className="disastercards-card">
//       <div className="disastercards-image">
//         <img src={image} alt={title} />
//       </div>
//       <div className="disastercards-text">
//         <h5>{title}</h5>
//         <div className="disastercards-desc-content">
//            {description}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FeatureCard;











// import React from 'react';

// const FeatureCard = ({ image, title, description }) => {
//   return (
//     <div className="disastercards-card">
//       <div className="disastercards-image">
//         <img src={image} alt={title} />
//       </div>
//       <div className="disastercards-text">
//         <h5>{title}</h5>
//         <div className="disastercards-desc-content">
//            {description}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FeatureCard;










import React from 'react';

const FeatureCard = ({ image, title, description, centered }) => {
  return (
    <div className="disastercards-card">
      <div className="disastercards-image">
        <img src={image} alt={title} />
      </div>
      <div className="disastercards-text">
        <h5>{title}</h5>
        {/* Conditionally add the 'centered-text' class */}
        <div className={`disastercards-desc-content ${centered ? 'centered-text' : ''}`}>
           {description}
        </div>
      </div>
    </div>
  );
};

export default FeatureCard;